require("component-responsive-frame/child");